import { Reducer } from "redux";

import { SocialFeedActionTypes } from "src/social-feed/action-types";
import { InteractionActionTypes } from './action-types';
import { InteractionsAction } from "./actions";

export interface IObjectInteractionsState {
    comments: Spintr.IComment[];
    commentsFailed: boolean;
    commentsLoaded: boolean;
    commentsIsLoading: boolean;
    likers: any[];
    likersFailed: boolean;
    likersIsLoading: boolean;
    likersLoaded: boolean;

}
export interface IInteractionsState {
    [objectId: number]: IObjectInteractionsState;
}

const initialState: IInteractionsState = {};
const defaultObjectState: IObjectInteractionsState = {
    comments: [],
    commentsFailed: false,
    commentsIsLoading: false,
    commentsLoaded: false,
    likers: [],
    likersFailed: false,
    likersIsLoading: false,
    likersLoaded: false,
}

const processComments = (comments: Spintr.IComment[]) => {
    const result: Spintr.IComment[] = [];

    for (const c of comments) {
        if (result.find(i => i.id === c.id)) {
            continue;
        }

        if (!c.likers) {
            c.likers = [];
        }

        result.push(c);
    }

    return result.sort((a, b) => 
        new Date(a.date).getTime() - new Date(b.date).getTime()
    );
};

export const interactionsReducer: Reducer<IInteractionsState, InteractionsAction> = (state = initialState, action): IInteractionsState => {
    switch (action.type) {
        case InteractionActionTypes.FetchCommentsPending:
            return {
                ...state,
                [action.meta.uberId]: {
                    ...(state[action.meta.uberId] || defaultObjectState),
                    comments: [],
                    commentsFailed: false,
                    commentsIsLoading: true,
                    commentsLoaded: false,
                },
            };

        case InteractionActionTypes.FetchCommentsRejected:
            return {
                ...state,
                [action.meta.uberId]: {
                    ...(state[action.meta.uberId] || defaultObjectState),
                    comments: [],
                    commentsFailed: true,
                    commentsIsLoading: false,
                    commentsLoaded: false,
                },
            };

        case InteractionActionTypes.FetchCommentsFulfilled:
            return {
                ...state,
                [action.meta.uberId]: {
                    ...(state[action.meta.uberId] || defaultObjectState),
                    comments: action.payload.data,
                    commentsFailed: false,
                    commentsIsLoading: false,
                    commentsLoaded: true,
                },
            };

        case InteractionActionTypes.SetComments:
            
            return {
                ...state,
                [action.meta.uberId]: {
                    ...(state[action.meta.uberId] || defaultObjectState),
                    comments: action.meta.comments,
                    commentsFailed: false,
                    commentsIsLoading: false,
                    commentsLoaded: true,
                },
            };

        case InteractionActionTypes.FetchLikersPending:
            return {
                ...state,
                [action.meta.uberId]: {
                    ...(state[action.meta.uberId] || defaultObjectState),
                    likers: [],
                    likersFailed: false,
                    likersIsLoading: true,
                    likersLoaded: false,
                },
            };

        case InteractionActionTypes.FetchLikersRejected:
            return {
                ...state,
                [action.meta.uberId]: {
                    ...(state[action.meta.uberId] || defaultObjectState),
                    likers: [],
                    likersFailed: true,
                    likersIsLoading: false,
                    likersLoaded: false,
                },
            };

        case InteractionActionTypes.FetchLikersFulfilled:
            return {
                ...state,
                [action.meta.uberId]: {
                    ...(state[action.meta.uberId] || defaultObjectState),
                    likers: action.payload.data,
                    likersFailed: false,
                    likersIsLoading: false,
                    likersLoaded: true,
                },
            };

        case InteractionActionTypes.SetLikers:
            return {
                ...state,
                [action.meta.uberId]: {
                    ...(state[action.meta.uberId] || defaultObjectState),
                    likers: action.meta.likers,
                    likersFailed: false,
                    likersIsLoading: false,
                    likersLoaded: true,
                },
            };

        case InteractionActionTypes.AddLike:
        case InteractionActionTypes.AddLikePending:
        case InteractionActionTypes.AddLikeFulfilled:
            if (state[action.meta.uberId]) {
                if (state[action.meta.uberId].likers.some(
                    (liker) => liker.id === (action.meta.identity?.id || action.meta.user.id) && ((liker.likeType || 0) === (action.meta.user.likeType || 0))
                )) {
                    return state;
                }

                if (state[action.meta.uberId].likers.some(
                    (liker) => liker.id === (action.meta.identity?.id || action.meta.user.id) && ((liker.likeType || 0) !== (action.meta.user.likeType || 0))
                )) {
                    return {
                        ...state,
                        [action.meta.uberId]: {
                            ...state[action.meta.uberId],
                            likers: state[action.meta.uberId].likers.map((liker: any) => {
                                return {
                                    ...liker,
                                    likeType: liker.id === (action.meta.identity?.id || action.meta.user.id) ?
                                        (action.meta.user.likeType || 0) :
                                        (liker.likeType || 0)
                                }
                            }),
                        },
                    };
                }
            }

            return {
                ...state,
                [action.meta.uberId]: {
                    ...(state[action.meta.uberId] || defaultObjectState),
                    likers: state[action.meta.uberId].likers.concat(
                        [(action.meta.identity || action.meta.user)]
                    ),
                },
            };

        case InteractionActionTypes.RemoveLike:
        case InteractionActionTypes.RemoveLikePending:
        case InteractionActionTypes.RemoveLikeFulfilled:
            const removeLikeIndex = state[action.meta.uberId].likers.findIndex(
                (liker) => liker.id === (action.meta.identity?.id || action.meta.user.id) && ((liker.likeType || 0) === (action.meta.user.likeType || 0))
            )

            if (removeLikeIndex === -1) {
                return {
                    ...state,
                    [action.meta.uberId]: {
                        ...(state[action.meta.uberId] || defaultObjectState),
                    },
                };
            }

            return {
                ...state,
                [action.meta.uberId]: {
                    ...(state[action.meta.uberId] || defaultObjectState),
                    likers: state[action.meta.uberId].likers.filter(
                        (_, index) => index !== removeLikeIndex
                    ),
                },
            };

        case InteractionActionTypes.AddComment:
        // case InteractionActionTypes.AddCommentFulfilled:
            if (!state[action.meta.comment.objectId] && action.meta.fromRealtime) {
                return state;
            }

            return {
                ...state,
                [action.meta.comment.objectId]: {
                    ...(state[action.meta.comment.objectId] || defaultObjectState),
                    comments: processComments([
                        ...state[action.meta.comment.objectId]?.comments,
                        action.meta.comment
                    ]),
                },
            };

        case InteractionActionTypes.UpdateComment:
            return {
                ...state,
                [action.meta.comment.objectId]: {
                    ...(state[action.meta.comment.objectId] || defaultObjectState),
                    comments: state[action.meta.comment.objectId].comments
                        .map(c => c.id === action.meta.comment.id ? action.meta.comment : c),
                },
            };

        case InteractionActionTypes.MarkCommentAsAnswer:
            return {
                ...state,
                ...Object.keys(state).reduce((newState, key) => {
                    const item = newState[key] as IObjectInteractionsState;

                    const containsComment = item.comments.find(x => x.id === action.meta.id);
                    if (!containsComment) {
                        return newState;
                    }
                    
                    return {
                        ...newState,
                        [key]: {
                            ...item,
                            comments: item.comments.map((c) => c.id === action.meta.id
                                ? {
                                    ...c,
                                    isAnswer: action.meta.value,
                                }
                                : c,
                            ),
                        },
                    };
                }, state),
            };

        case InteractionActionTypes.RemoveComment:
        case InteractionActionTypes.RemoveCommentPending:
        case InteractionActionTypes.RemoveCommentFulfilled:
            return {
                ...state,
                ...Object.keys(state).reduce((newState, key) => {
                    const item = newState[key] as IObjectInteractionsState;

                    const containsComment = item.comments.find(x => x.id === action.meta.id);
                    if (!containsComment) {
                        return newState;
                    }

                    return {
                        ...newState,
                        [key]: {
                            ...item,
                            comments: item.comments.filter(c => c.id !== action.meta.id),
                        },
                    };
                }, state),
            };

        case SocialFeedActionTypes.RemotePostDeleted:
            if (action.uberType !== 6) {
                return {
                    ...state,
                    [action.id]: undefined,
                };
            }

            return {
                ...state,
                ...Object.keys(state).reduce((newState, key) => {
                    if (isNaN(+key)) {
                        return newState;
                    }

                    const id = parseInt(key, 10);
                    if (!newState[id]) {
                        return newState;
                    }

                    const hasComment = newState[id].comments.some(
                        c => c.id === action.id || (c.comments || []).some(
                            (cc) => cc.id === action.id
                        )
                    );

                    if (!hasComment) {
                        return newState
                    }

                    return {
                        ...newState,
                        [id]: {
                            ...newState[id],
                            comments: state[id].comments
                                .filter((c) => c.id !== action.id)
                                .map((comment) => ({
                                    ...comment,

                                    comments: (comment.comments || []).filter(
                                        (c) => c.id !== action.id
                                    )
                                })),
                        },
                    };
                }, state),
                [action.id]: undefined,
            };

        case InteractionActionTypes.Clear:
            return {...initialState};

        default:
            return state;
    }
};

export default interactionsReducer
